<template>
	<div class="info">
		<div class="header">
			<div class="title">客户信息</div>
			<!-- <div class="btn" @click="edit" v-if="!showForm&&garbageFlag!=1">编辑</div> -->
		</div>
		<blockSpacList :list="list" labelWidth="100px"></blockSpacList>
		<!-- <chatCustEdit
			v-if="showForm"
			:attributes="options"
			:customerInfo="customerInfo"
			@cancelmodifying="cancel"
		></chatCustEdit> -->
	</div>
</template>
<script>
import blockSpacList from '@/components/client/clientModule/blockSpacList.vue';
import Tag from '@/components/iglobalwin/dataList/tag.vue';
// import chatCustEdit from '@/components/email/emailDataList/components/modifyingCustomerInformation.vue';
// import chatCustEdit from '@/components/iglobalwin/form-warps/form-panel/chat-cust-edit.vue';
import chatSer from '@/backend/services/chat/chatSer.js';
import { mapActions } from 'vuex';
export default {
	props: {
		id: {
			type: String,
		},
		garbageFlag: {
			type: Number,
			default: 0,
		},
		followupName: {
			type: String,
		},
	},
	data() {
		return {
			list: {},
			showForm: false,
			options: {},
			customerInfo: {},
			optionsValue: {},
		};
	},
	watch: {
		followupName: {
			handler(val) {
				if (val) {
					this.getCustomerInfo();
				}
			},
			deep: true,
			immediate: true,
		},
		showForm: {
			handler(val) {
				// this.customerOptions();
				this.list ={
					row1: [
						{
							label: '客户名称',
							value: this.info.nickname,
						},
					],
					row2: [
						{
							label: '客户来源',
							value: this.info.websiteType,
						},
					],
					row3: [
						{
							label: '跟进人',
							value: this.info.followupName,
						},
					],
					row4: [
						{
							label: '最近跟进时间',
							value: this.info.recentFollowupTimeStr,
						},
					],
				}
					
			},
		},
		id: {
			handler(val) {
				if (val) {
					this.getCustomerInfo();
				}
			},
			immediate: true,
			deep: true,
		},
	},
	mounted() {
		this.getCustomerInfo();
	},
	methods: {
		...mapActions(['getCustomerOptions']),
		edit() {
			this.showForm = true;
		},
		cancel() {
			this.getCustomerInfo();
			this.customerOptions();
			this.showForm = false;
		},
		async customerOptions() {
			var options = await this.getCustomerOptions();
			this.options = {
				...this.optionsValue,
				...options,
			};
		},
		getStr(val)
		{
			switch (val) {
						case '0':
							return 'PC网站询盘';
						case '1':
							return 'APP网站询盘';
						case '2':
							return '邮件询盘';
						case '3':
							return '社交询盘';
						case '4':
							return '自建站询盘';
						case '5':
							return 'Messenger询盘';
						case '6':
							return '手动录入';
						case '7':
							return 'FB表单询盘';
							
			}
		},
		async getCustomerInfo() {
			let res = await chatSer.headerDetail({
				id: this.id,
				type: 2,
			});
			if (res) {
				
				this.info = res.data;
				let websiteType=this.getStr(res.data.websiteType);
				// this.customerInfo = {
				// 	customerName: res.data.customerName,
				// 	customerSourceId: res.data.customerSourceId,
				// 	id: res.data.id,
				// };
				// this.optionsValue = {
				// 	groupId: this.info.groupId,
				// 	tagValue: this.info.tag,
				// };
				// this.customerOptions();
				
				this.list = {
					row1: [
						{
							label: '客户名称',
							value: this.info.nickname,
						},
					],
					row2: [
						{
							label: '客户来源',
							value:websiteType,
						},
					],
					row3: [
						{
							label: '跟进人',
							value: this.info.followupName,
						},
					],
					row4: [
						{
							label: '最近跟进时间',
							value: this.info.recentFollowupTimeStr,
						},
					],
					// row5: [
					// 	{
					// 		label: '客户分组',
					// 		value: this.info.group,
					// 	},
					// ],
					// row6: [
					// 	{
					// 		label: '客户标签',
					// 		type: Tag,
					// 		col: 24,
					// 		tableData: {
					// 			bind: 'labelList',
					// 			labelStyleKey: 'style',
					// 			labelNameKey: 'name',
					// 			tagEllipsis: false,
					// 		},
					// 		scope: {
					// 			row: {
					// 				labelList: this.info.tag || [],
					// 			},
					// 		},
					// 	},
					// ],
				};
				// this.countryAndIndustry = await this.getCountryAndIndustry();
				// this.setCardList();
				// this.setFormData();
			}
		},
	},
	components: {
		blockSpacList,
		// chatCustEdit,
		Tag,
	},
};
</script>
<style lang="scss" scoped>
.info {
	padding: 20px;
	font-size: 15px;

	.header {
		font-size: 16px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;

		.btn {
			cursor: pointer;
			font-size: 14px;
			font-weight: 400;
			color: #3da1ff;
		}
	}
}
</style>
